/** Normalize collective.elements from API (object or legacy JSON string). */
export default function normalizeSpaceElements(raw) {
  if (raw == null) return {};

  let parsed = raw;
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return {};
    try {
      parsed = JSON.parse(trimmed);
    } catch {
      return {};
    }
  }

  if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
    return parsed;
  }

  return {};
}
